var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", {
    attrs: { contenteditable: _vm.canEdit },
    domProps: { innerHTML: _vm._s(_vm.innerText) },
    on: {
      focus: function($event) {
        _vm.isLocked = true
      },
      blur: function($event) {
        _vm.isLocked = false
        _vm.getLastPosition()
      },
      input: _vm.changeText
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-45abbb2e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45abbb2e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/pages/admin/index/reject-textarea.vue
// module id = null
// module chunks = 